// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_segmentGroup__mGftK {
  padding: 12px;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 12px;
  box-shadow: rgba(107, 167, 168, 0.45) 0px 1px 1px, rgba(107, 167, 168, 0.26) 0px 0px 1px 1px;
  border-radius: 12px;
}
.styles_segmentGroup__mGftK h4 {
  font-weight: 600;
  color: #6ba7a8;
}
.styles_segmentGroup__mGftK div {
  display: block;
}
.styles_segmentGroup__mGftK div .styles_chunkWrapper__vUVqo {
  position: relative;
  display: inline;
}
.styles_segmentGroup__mGftK div .styles_chunkWrapper__vUVqo .styles_chunk__HxC4i {
  margin-right: 4px;
  display: inline;
  transition: all 0.2s ease-in-out;
  line-height: 1.2;
  padding: 0 2px;
  border-radius: 8px;
}
.styles_segmentGroup__mGftK div .styles_chunkWrapper__vUVqo .styles_chunk__HxC4i:hover {
  background-color: #f1f1f1;
  cursor: pointer;
}
.styles_segmentGroup__mGftK div .styles_chunkWrapper__vUVqo .styles_chunk__HxC4i.styles_selected__gjZav {
  background-color: #ccc;
}
.styles_segmentGroup__mGftK div .styles_chunkWrapper__vUVqo .styles_chunk__HxC4i.styles_playing__1QiEq {
  background-color: #6ba7a8;
  color: white;
}
.styles_segmentGroup__mGftK div .styles_chunkWrapper__vUVqo .styles_image__pLhZl {
  width: 12px;
  height: auto;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5));
  display: none;
}
.styles_segmentGroup__mGftK div .styles_chunkWrapper__vUVqo.styles_selected__gjZav .styles_image__pLhZl {
  display: inline;
  margin-right: 4px;
}
.styles_segmentGroup__mGftK div .styles_chunkWrapper__vUVqo.styles_selected__gjZav .styles_image__pLhZl:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/Transcript/SegmentGroup/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,SAAA;EACA,4FAAA;EAEA,mBAAA;AAAF;AACE;EACE,gBAAA;EACA,cAAA;AACJ;AACE;EACE,cAAA;AACJ;AAAI;EACE,kBAAA;EACA,eAAA;AAEN;AADM;EACE,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAGR;AAFQ;EACE,yBAAA;EACA,eAAA;AAIV;AAFQ;EACE,sBAAA;AAIV;AAFQ;EACE,yBAAA;EACA,YAAA;AAIV;AADM;EACE,WAAA;EACA,YAAA;EACA,mDAAA;EACA,aAAA;AAGR;AACQ;EACE,eAAA;EACA,iBAAA;AACV;AACU;EACE,eAAA;AACZ","sourcesContent":[".segmentGroup {\n  padding: 12px;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 12px;\n  box-shadow: rgba(107, 167, 168, 0.45) 0px 1px 1px,\n    rgba(107, 167, 168, 0.26) 0px 0px 1px 1px;\n  border-radius: 12px;\n  h4 {\n    font-weight: 600;\n    color: #6ba7a8;\n  }\n  div {\n    display: block;\n    .chunkWrapper {\n      position: relative;\n      display: inline;\n      .chunk {\n        margin-right: 4px;\n        display: inline;\n        transition: all 0.2s ease-in-out;\n        line-height: 1.2;\n        padding: 0 2px;\n        border-radius: 8px;\n        &:hover {\n          background-color: #f1f1f1;\n          cursor: pointer;\n        }\n        &.selected {\n          background-color: #ccc;\n        }\n        &.playing {\n          background-color: #6ba7a8;\n          color: white;\n        }\n      }\n      .image {\n        width: 12px;\n        height: auto;\n        filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5));\n        display: none;\n      }\n\n      &.selected {\n        .image {\n          display: inline;\n          margin-right: 4px;\n\n          &:hover {\n            cursor: pointer;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"segmentGroup": `styles_segmentGroup__mGftK`,
	"chunkWrapper": `styles_chunkWrapper__vUVqo`,
	"chunk": `styles_chunk__HxC4i`,
	"selected": `styles_selected__gjZav`,
	"playing": `styles_playing__1QiEq`,
	"image": `styles_image__pLhZl`
};
export default ___CSS_LOADER_EXPORT___;
